import { Vue, Component } from "vue-property-decorator";
import { busy } from "@/loader";

@Component
export class BusyMixin extends Vue {
	public get isBusy(): boolean {
		return busy.status;
	}
}
